






































































import Facebook from './SingleButtons/Facebook.vue';
import Mail from './SingleButtons/Mail.vue';
import Twitter from './SingleButtons/Twitter.vue';
import WhatsApp from './SingleButtons/WhatsApp.vue';

import Vue from 'vue';

export default Vue.extend({
  components: {
    Facebook,
    Mail,
    Twitter,
    WhatsApp,
  },
  props: {
    description: { type: String, required: true },
    title: { type: String },
    image: { type: String },
    facebook: { type: Boolean },
    twitter: { type: Boolean },
    whatsapp: { type: Boolean },
    mail: { type: Boolean },
  },
  computed: {
    link: function() {
      return document.location.toString();
    },
    parsedDescription: function() {
      return this.description.replace('<br>', '\n').replace(/<\/?[^>]+(>|$)/g, '');
    },
  },
});
